import Head from 'next/head';

import { SimpleLayout } from '../../src/components/Layouts';
import MentionsLegales from '../../src/components/legal/MentionsLegales';

const Index = () => (
  <SimpleLayout>
    <Head>
      <title key="title">YUPWEGO - Mentions Légales</title>
    </Head>
    <MentionsLegales />
  </SimpleLayout>
);

export default Index;
